export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "parsePixelDataToGridNftTransactionData.worker.133270b9a09967bb45f4.worker.js");
}
